import { z } from 'zod';

import { MESSAGES } from '../constants/messages';
import { BreakSchema } from './Break';

export const MessageSchema = z.object({
    message: MESSAGES,
    currentViewer: z.string(),
    breakInfo: BreakSchema,
    rerip: z.boolean(),
});

export type Message = z.infer<typeof MessageSchema>;
